import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './mapModeChip.css';

/**
 * Phone-only control for building a boundary from parcel lots.
 *
 * On a phone the finish action would otherwise live inside the parcels sheet,
 * so ending the mode would mean reopening the sheet over the map you are
 * working on. This puts the running count and the finish action on the map,
 * with an explicit exit next to it: a mode you cannot leave is worse than no
 * mode at all.
 *
 * Finishing hands off to the same union-and-save path the desktop popover
 * uses, so there is one way to create a boundary from lots, not two.
 */
export function ParcelLotSelectControl({ show, count = 0, busy = false, onDone, onCancel }) {
  if (!show) return null;

  const chosen = Number(count) || 0;
  const hasSelection = chosen > 0;

  return (
    <div className="map-mode-chip-group" data-testid="parcel-lot-select-control">
      <button
        type="button"
        className="map-mode-chip map-mode-chip--active"
        onClick={onDone}
        // Nothing to save at zero, and a dead-looking button is clearer than
        // one that silently does nothing. Cancel stays live regardless.
        disabled={busy || !hasSelection}
        aria-busy={busy}
        aria-label={
          hasSelection
            ? `Finish boundary from ${chosen} parcel${chosen === 1 ? '' : 's'}`
            : 'Tap parcels to add them to the boundary'
        }
        title={hasSelection ? 'Finish and name the boundary' : 'Tap parcels on the map to add them'}
        data-testid="parcel-lot-select-done"
      >
        <span className="map-mode-chip__label">
          {busy ? 'Building…' : `Parcels chosen: ${chosen}`}
        </span>
      </button>
      <button
        type="button"
        className="map-mode-chip map-mode-chip--icon"
        onClick={onCancel}
        disabled={busy}
        aria-label="Cancel building a boundary from parcels"
        title="Cancel"
        data-testid="parcel-lot-select-cancel"
      >
        <FaTimes aria-hidden="true" />
      </button>
    </div>
  );
}

export default ParcelLotSelectControl;
